import { render, staticRenderFns } from "./regulatoryHeader.vue?vue&type=template&id=2aa51ab9&scoped=true&"
import script from "./regulatoryHeader.vue?vue&type=script&lang=js&"
export * from "./regulatoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./regulatoryHeader.vue?vue&type=style&index=0&id=2aa51ab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa51ab9",
  null
  
)

export default component.exports